import { useMemo } from "react";

import { resourceColumnMapping } from "app/components/column-mapping/resourceColumnMapping";

import type { RawColumn } from "app/components/column-mapping/formatColumns";
import type { ResourceDataField } from "app/views/overview/policies/details/components/__generated__/PolicyResourcesRefetchQuery.graphql";

export function useResourceColumns(
  resourceType: string,
): [RawColumn[], ResourceDataField[]] {
  const mapping = useMemo(
    () => resourceColumnMapping[resourceType],
    [resourceType],
  );
  // As requests for resource data with fields now returns values rather than the nested object,
  // we need to use a non-JMESPath string as the field name to prevent the MUI datagrid trying
  // to get the value from a nested object. We try to use the headerName with spaces removed, or
  // fall back to the path expression with periods removed (though other JMESPath syntax could
  // still cause issues).
  const columns = useMemo(() => {
    return (mapping?.columns ?? []).map((column) => ({
      ...column,
      field:
        column.headerName?.replace(/ /g, "") || column.field.replace(/\./g, ""),
    }));
  }, [mapping?.columns]);

  const fields = (mapping?.columns ?? []).map((column) => ({
    name:
      column.headerName?.replace(/ /g, "") || column.field.replace(/\./g, ""),
    path: column.field,
  }));

  return [columns, fields];
}
